export const theme = {
    ms: {
        background: {
            "ct-blue": "#1E88E6",
            "ct-green": "#0C8016",
            "ct-blue-2": "#0053f4",
            "ct-navy": "#0A1F44"
        }
    }
}

export const getCtPrimaryBtn = (gradeLevel) => (gradeLevel >= 9 ? "navy" : "green")

export const getMsBg = (gradeLevel) => {
    if (gradeLevel <= 2) {
        return theme.ms.background["ct-blue"]        // G2 (K–2)
    }
    else if (gradeLevel >= 9) {
        return theme.ms.background["ct-navy"]        // HS (9–12) — navy blue
    }
    else if (gradeLevel >= 6) {
        return theme.ms.background["ct-green"]       // MS (6–8)
    } else {
        return theme.ms.background["ct-blue-2"]      // G3–G5
    }
}